import {
  KeywordTypes,
  type KeywordTypes as KeywordType,
} from '@/api/keywordApi/client';

export const isHotelKeyword = (keyword: string) =>
  keyword.startsWith(KeywordTypes.hotel);

export const isCityKeyword = (keyword: string) =>
  keyword.startsWith(KeywordTypes.city);

export const isDestinationKeyword = (keyword: string) =>
  keyword.startsWith(KeywordTypes.destination);

export const isCountryKeyword = (keyword: string) =>
  keyword.startsWith(KeywordTypes.country);

export const getKeywordType = (keyword: string): KeywordType | '' => {
  if (isHotelKeyword(keyword)) {
    return KeywordTypes.hotel;
  }
  if (isCityKeyword(keyword)) {
    return KeywordTypes.city;
  }
  if (isDestinationKeyword(keyword)) {
    return KeywordTypes.destination;
  }
  if (isCountryKeyword(keyword)) {
    return KeywordTypes.country;
  }
  return '';
};
